export const notificationConstants = {
    ADD_NOTIFICATION: "ADD_NOTIFICATION",
    REMOVE_NOTIFICATION: "REMOVE_NOTIFICATION",
    REMOVE_SAVED_NOTIFICATION: "REMOVE_SAVED_NOTIFICATION",
    SET_MAX_NOTIFICATIONS: "SET_MAX_NOTIFICATIONS",
    SAVE_NOTIFICATION: "SAVE_NOTIFICATION",
    SET_UNREAD_NOTIFICATIONS: "SET_UNREAD_NOTIFICATIONS",
    SET_DND: "SET_DND"
};